import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useNotification } from "../../contexts/NotificationContext";
import { authFetch } from '../../utils/authFetch';

const NovoAviso = () => {
    const { showNotification } = useNotification();
    const navigate = useNavigate();

    const [description, setDescription] = useState('');
    const [notificationLevel, setNotificationLevel] = useState(0);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await authFetch('notification', {
                method: 'POST',                
                body: JSON.stringify({ description, notificationLevel })
            });

            if (!response.ok) throw new Error('Erro ao criar aviso');

            showNotification("success", "Aviso criado com sucesso!");
            navigate('/Avisos');
        } catch (error) {
            console.error(error);
            showNotification("danger", "Erro ao criar aviso");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Novo Aviso</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6">
                                    <div className="mb-3">
                                        <label>Descrição</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Nível</label>
                                        <select
                                            className="form-control"
                                            value={notificationLevel}
                                            onChange={(e) => setNotificationLevel(parseInt(e.target.value))}
                                        >
                                            <option value={0}>Normal</option>
                                            <option value={1}>Importante</option>
                                        </select>
                                    </div>
                                    <div className="card-footer" style={{ paddingLeft: "0" }}>
                                        <Link to={'/Avisos'} className="btn btn-info btn-sm" >Voltar</Link>
                                        <button type="submit" className="btn btn-primary btn-sm mx-1">Salvar</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovoAviso;
